import { render, staticRenderFns } from "./ModalCommentList.vue?vue&type=template&id=731189ac&scoped=true"
import script from "./ModalCommentList.vue?vue&type=script&lang=js"
export * from "./ModalCommentList.vue?vue&type=script&lang=js"
import style0 from "./ModalCommentList.vue?vue&type=style&index=0&id=731189ac&prod&lang=scss&scoped=true"
import style1 from "./ModalCommentList.vue?vue&type=style&index=1&id=731189ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731189ac",
  null
  
)

export default component.exports